import { Category } from '@/types/Category';
import { Template } from '@/types/Template';

export function getTemplatesByCategory(templates: Template[], category: Category) {
    return templates.filter((template) => {
        return template.categories.find((id) => id === category.id);
    });
}
